import { useState, useEffect, useRef, useMemo, useCallback} from 'react'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDmImei, writeRsCmdSettings, btnSelect_send_sms } from '../../../../redux/actions';
import Button from "../../../UI/Button/Button";
import Modal from '../../../UI/Modal/Modal'
import {Loader} from '../../../UI/Loader/Loader';
import '../RsConfig.css'

export default React.memo(function RsNotice() {
    const parameter = useSelector((state) => state.dmimei?.data[0]);
    const dispatch = useDispatch(); 
    const [modal, setModal] = useState(false)
    const [inputvalue, setInputvalue] = useState();
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    function onClickNumberOpen() {
        setInputvalue('');
        setModal(true);
        setHasError(false);
    }

    const onClickNumberSave=useCallback(async(inputvalue)=>{
        if (!inputvalue || inputvalue.trim() === '') {
            setHasError(true)
            return;
        } 
        
        setModal(false);
        setInputvalue('');
        setHasError(false);
        if (inputvalue.length===11) {
            setIsLoading(true);  
        try{
         const num = 50;
         const phoneNumber = inputvalue.slice(1);    
            await dispatch(writeRsCmdSettings(parameter?.imei, phoneNumber, num));
            await dispatch(getDmImei(parameter?.imei))
        } catch (error) {
            console.error("Ошибка при сохранении или обновлении данных: ", error);
            if (isMounted.current) {
                alert(`Ошибка при сохранении: ${error.message}`);
            }         
        } finally {
            if (isMounted.current) {
                setIsLoading(false);
            }
        }
    } else {alert(`Номер не сохранен. Проверьте еще раз.`)}    
    }, [parameter?.imei, dispatch]);
    
    const number = useMemo(() => {
            return parameter?.cmd11 ? `8${parameter?.cmd11}` : '...';
        }, [parameter?.cmd11]); // Зависит только от cmd11, а не от всего parameter

    // определяем четность config_id (нечет-без смс, чет-с смс)
    const isEven = n => n % 2 === 0;   

    const SelectSendSms=useCallback(() => {
    const value  = isEven(parameter?.config_id) ? (1) : (0);
    const arOptions = ['Нет', 'Да'];
    const options = arOptions.map((text, index) => {
        return <option key={index} value={index}>{text}</option>;          
    });

        const onClickSaveSendSMS = async() => {
        const newConfigId  = isEven(parameter?.config_id) ? (
            parameter?.config_id * 1 - 1 ) : (
            parameter?.config_id * 1 + 1); 

        if (parameter?.config_id !== (newConfigId )) {
           
            if (parameter?.cmd11 !==null) {
            dispatch(btnSelect_send_sms(parameter?.imei, newConfigId ))
            .then(() =>  dispatch(getDmImei(parameter?.imei)))
            .catch((error) => console.error("Ошибка при сохранении или обновлении данных: ", error));
            }  else {
                alert("Команда отклонена. Задайте номер телефона.");
            }  
        }  
    }
    return (
        <div className='ParamInput'>
            <label>Отправлять SMS при изменении состояния насосного агрегата:</label>
            <select className='DmSelect' value={value} 
                onChange={onClickSaveSendSMS}>
                {options}
             </select> 
         </div> 
    )
 }, [parameter?.config_id])

    return(
        <div className='cardDm'>
            <h3>Оповещение</h3> 
            <div className='ParamInput'>
             <label>Номер телефона для оповещения:</label>
                {isLoading ? <Loader /> :
                <Button  onClick={()=>onClickNumberOpen()}>
                    <span className='buttonInput'>{number}</span>
                </Button>}    
            </div> 
            <div className='selectSms'>  
                <SelectSendSms /> 
            </div> 

            <Modal open={modal}>
                     <div className='modalHeader'>
                        <h3>Введите новое значение</h3>
                        <svg  onClick={()=>setModal(false)} height="30" viewBox="0 0 200 200" width="30">    
                            <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                        </svg> 
                    </div>
                    <label className='labelInfo'>Номер телефона для оповещения (начинается с 8):</label>
                    <h4 className='labelInfoQuet'>
                    {hasError ? ("Передумали?") : ("Желаете установить "+`${inputvalue}`+'?')}</h4>
                    <div className='contentControl'>
                        <input type='tel' className='input' value={inputvalue} 
                        placeholder="Введите номер: 8..."
                        onChange={e=>setInputvalue(e.target.value)}
                        style={{border: hasError ? '1px solid red' : null}} />

                     <div className='modalButton' >
                        <Button onClick={() => setModal(false)} color="#d2e9d2">Отмена</Button>
                        <Button onClick={()=>onClickNumberSave(inputvalue)} color="#4bdd4b">Сохранить</Button>
                     </div>
                     </div>
                </Modal>
        </div>
    )
});